import { APARENCIA_ESTADO_SERVICO } from '@/constants/status.constants';
import { formatarPercentual } from '@/helpers/formatacao.helpers';
import { estadoEfetivo } from '@/helpers/status.helpers';
import type { FrescorDados, Servico } from '@/types/status.types';
import { BarraDisponibilidade } from './barra-disponibilidade';

type ListaServicosProps = {
  servicos: Servico[];
  janelaDias: number;
  frescor: FrescorDados;
};

export const ListaServicos = ({ servicos, janelaDias, frescor }: ListaServicosProps) => {
  return (
    <section className="cartao-status" aria-labelledby="titulo-servicos">
      <div className="flex items-baseline justify-between gap-3">
        <h2 id="titulo-servicos" className="m-0 text-[15px] font-semibold tracking-[-0.01em]">
          Serviços
        </h2>
        <span className="text-[12px] text-muted-foreground">
          Disponibilidade dos últimos {janelaDias} dias
        </span>
      </div>

      {servicos.length === 0 ? (
        <p className="mt-4 mb-0 text-[14px] text-muted-foreground">
          Nenhum serviço publicado no momento.
        </p>
      ) : (
        <ul className="mt-1.5 list-none p-0">
          {servicos.map((servico) => {
            const estado = estadoEfetivo(servico.estado, frescor);
            const aparencia = APARENCIA_ESTADO_SERVICO[estado];
            const disponibilidade = `${formatarPercentual(servico.disponibilidade)} de disponibilidade`;

            return (
              <li key={servico.chave} className="border-t border-border py-4">
                {/*
                  No desktop as três informações cabem numa linha só. No celular a
                  descrição desce para a sua própria linha (order-3 w-full) e o estado
                  é empurrado para a direita, senão nome, descrição e estado se
                  intercalam de formas diferentes a cada serviço.
                */}
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                  <span className="text-[14px] font-medium">{servico.nome}</span>
                  <span className="order-3 w-full text-[12px] text-muted-foreground sm:order-none sm:w-auto sm:min-w-[120px] sm:flex-1">
                    {servico.descricao}
                  </span>
                  <span
                    className="ml-auto inline-flex items-center gap-[7px] text-[13px] font-medium whitespace-nowrap sm:ml-0"
                    style={{ color: aparencia.cor }}
                  >
                    <span
                      aria-hidden="true"
                      className="size-2 rounded-full"
                      style={{ background: aparencia.cor }}
                    />
                    {aparencia.rotulo}
                  </span>
                </div>

                <BarraDisponibilidade
                  dias={servico.dias}
                  janelaDias={janelaDias}
                  disponibilidade={disponibilidade}
                  nomeServico={servico.nome}
                />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
